import { useEffect, useState } from 'react';
import { RoomDetailsData } from '../room.types';
interface SeenBannersMap {
  [roomCode: string]: boolean;
}
export const useShouldShowStudentsOnlyBanner = (roomCode?: string, roomTeamSettings?: RoomDetailsData['teamSettings']): [boolean, () => void] => {
  const isStudentsOnlyRoom = Boolean(roomTeamSettings?.studentsOnly ?? false);
  const [shouldShowBanner, setShouldShowBanner] = useState<boolean>(false);
  useEffect(() => {
    if (!isStudentsOnlyRoom || !roomCode) {
      setShouldShowBanner(false);
      return;
    }
    const storedBanners = localStorage.getItem('studentsOnlyBannersSeen');
    const seenBanners: SeenBannersMap = storedBanners ? (JSON.parse(storedBanners) as SeenBannersMap) : {};
    const hasSeenBanner = seenBanners[roomCode] === true;
    setShouldShowBanner(!hasSeenBanner);
  }, [isStudentsOnlyRoom, roomCode]);
  const onClose = () => {
    if (!roomCode) return;
    const storedBanners = localStorage.getItem('studentsOnlyBannersSeen');
    const seenBanners: SeenBannersMap = storedBanners ? (JSON.parse(storedBanners) as SeenBannersMap) : {};
    seenBanners[roomCode] = true;
    localStorage.setItem('studentsOnlyBannersSeen', JSON.stringify(seenBanners));
    setShouldShowBanner(false);
  };
  return [shouldShowBanner, onClose];
};